export default "__VITE_ASSET__DO77Z0nY__"